"use strict";

// The following colors may not be accessible with text color or inverse white on this background color. They do not all pass WCAG AA Color Contrast Ratios.
// https://webaim.org/resources/contrastchecker/?fcolor=FFFFFF&bcolor=FFC20E
module.exports = {
  'global-setup': '#2A739E',
  'service-cloud': '#7f2443',
  'industry-cloud': '#4c2248',
  'sales-cloud': '#00857d',
  'commerce-cloud': '#41693d',
  'community-cloud': '#ffc20e',
  'marketing-cloud': '#ea7600',
  quip: '#cf451d'
};